import { TransactCampusCardAccountType } from './transact_campus_card_account_type.js';

export function name(accountType: TransactCampusCardAccountType): string {
  switch (accountType) {
    case TransactCampusCardAccountType.StoredValue:
      return 'Stored Value';
    case TransactCampusCardAccountType.MealPlan:
      return 'Meal Plan';
    case TransactCampusCardAccountType.CashEquivalency:
      return 'Cash Equivalency';
  }
}
